import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import ActionForm from './ActionForm';
import { ActionList } from '../../common/actions';
import LoginActionForm from './action/login/LoginActionForm';
import CollectionActionForm from './action/collection/CollectionActionForm';
import EmailActionForm from './action/email/EmailActionForm';
import CollectionUpdateFieldForm from './action/collection/CollectionUpdateFieldForm';
import DynamicPageRedirect from './action/dynamic-page-redirect/DynamicPageRedirect';
import ImportExportItem from './action/collection/ImportExportItem';
import SendDataToExternalApiActionForm from './action/sendDataToExternalApi/SendDataToExternalApiActionForm';
import { SwitchEntityForm } from './action/switch-entity/SwitchEntityForm';
import InfoBox from '../../common/custom/InfoBox';
import actionDescription from './docs/actionDescription';
import { CollectionitemWithUserForm } from './action/collection/CollectionitemWithUserForm';
import DynamicOpenModal from './action/dynamicOpenModal/DynamicOpenModal';
import { ReferenceDropdown } from './action/referenceDropdown/ReferenceDropdown';
import SwitchTenantModal from './action/switchTenant/SwitchTenantModal';
import { CollectionItemWithReferenceItemForm } from './action/collection/CollectionItemWithReferenceItemForm';
import SmsActionForm from './action/sms/SmsActionForm';
import { SUPABASE, DIRECTUS, APP_WRITE, XANO, MYSQL } from 'drapcode-constant';
import AuthorizeDataSourceActionForm from './action/externalDataSource/authorize/AuthorizeDataSourceActionForm';
import { drapcodeIcon } from '../../common/custom/icon-library';
import ExternalSourceActionForm from './action/externalDataSource/ExternalSourceActionForm';
import { PdfToTextForm } from './action/collection/PdfToText';
import AgreementActionForm from './action/agreement/AgreementActionForm';
import DynamicOpenSubpage from './action/dynamicOpenModal/DynamicOpenSubpage';
import UpdateCollectionCellData from './action/tabulator/UpdateCollectionCellData';
import { OAuth2LoginForm } from './action/oAuth2/OAuth2LoginForm';
import { AmazonTextractForm } from './action/collection/amazonTextract';
import { PageRedirect } from './action/page-redirect/PageRedirect';
import BrowserStorageActionForm from './action/others/BrowserStorageActionForm';
import {
  CustomTermsAnonymizationForm,
  NlpAnonymizationForm,
} from './action/text-anonymization/CustomTermsAnonymization';
import { JavaScriptEditorForm } from './action/runJavaScript/JavaScriptEditorForm';
import { AddUserToTenantForm } from './action/addUserToTenant/AddUserToTenantForm';
import { CustomPageRedirect } from './action/navigation/CustomPageRedirect';
import { BulkCollectionEdit } from './action/collection/BulkCollectionEdit';
import FunctionExecution from './action/customFunction/FunctionExecution';
import SocketIOActionForm from './action/socket-io/SocketIOActionForm';
import FloatingModal from './action/snippets/FloatingModal';
import { UserWithTenantsAndSettingEventFieldForm } from './action/login/UserWithTenantsAndSettingEventFieldForm';
import { DownloadPDFTemplate } from './action/pdf/DownloadPDFTemplate';
import { GenerateOTPForm } from './action/otp/GenerateOTPForm';
import { CloneCollectionItemForm } from './action/collection/CloneCollectionItemForm.js';

class ActionFormModal extends Component {
  actionData = (action) => {
    let actionData = ActionList.find((param) => {
      return param.name === action.name && param.label === action.label;
    });

    //Fallback: When action label is different than the param.label declared in Action List
    if (!actionData) {
      actionData = ActionList.find((param) => {
        return param.name === action.name;
      });
    }
    return actionData;
  };
  actionForm = (eventAction, actionData) => {
    const { actions, hideModal, selectedEvent, showLoaderForAction, projectId, events, version } =
      this.props;
    //TODO: Need to refactor
    const { name, source } = eventAction;
    switch (name) {
      case 'loginUser':
      case 'loginUserWithToken':
      case 'loginUserWithFirebase':
      case 'loginUserWithXano':
      case 'verifyTwoFactorAuthentication':
        return (
          <LoginActionForm
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
            show2AuthPage={name !== 'verifyTwoFactorAuthentication'}
          />
        );
      case 'saveCollection':
      case 'updateCollection':
      case 'saveCollectionDraft':
      case 'updateCollectionDraft':
        return (
          <CollectionActionForm
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
          />
        );
      case 'updateCollectionOnPageLoad':
      case 'updateCollectionFieldDerivedField':
      case 'updateCollectionFieldBrowserSession':
        return (
          <CollectionUpdateFieldForm
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
          />
        );
      case 'dynamicPageRedirect':
        return (
          <DynamicPageRedirect
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
          />
        );
      case 'sendDynamicEmail':
        return (
          <EmailActionForm
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
          />
        );
      case 'sendForEsign':
        return (
          <AgreementActionForm
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
          />
        );
      case 'sendDynamicMessage':
        return (
          <SmsActionForm
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
          />
        );
      case 'exportCollectionItem':
      case 'importCollectionItem':
        return (
          <ImportExportItem
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
          />
        );
      case 'sendDataToExternalApi':
        return (
          <SendDataToExternalApiActionForm
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
            externalApiType={source || ''}
          />
        );
      case 'sendDataToExternalSource':
      case 'sendDataToExternalSourceAndFileDownload':
        return (
          <ExternalSourceActionForm
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
            externalApiType={source || ''}
          />
        );
      case 'authorizeWithExternalDataSource':
        return (
          <AuthorizeDataSourceActionForm
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
            externalApiType={source || ''}
          />
        );
      case 'switchEntity':
        return (
          <SwitchEntityForm
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
          />
        );
      case 'saveUserWithCollectionReference':
        return (
          <CollectionitemWithUserForm
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
          />
        );
      case 'saveCollectionWithReferenceItems':
      case 'updateCollectionWithReferenceItems':
        return (
          <CollectionItemWithReferenceItemForm
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
          />
        );
      case 'conditionalOpenModal':
        return (
          <DynamicOpenModal
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
          />
        );
      case 'conditionalOpenSubpage':
        return (
          <DynamicOpenSubpage
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
          />
        );
      case 'referenceDropDownOnChange':
        return (
          <ReferenceDropdown
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
          />
        );
      case 'switchUserTenant':
      case 'switchSubTenant':
        return (
          <SwitchTenantModal
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
          />
        );
      case 'pdfToText':
      case 'anyFileToText':
        return (
          <PdfToTextForm
            projectId={projectId}
            selectedEvent={selectedEvent}
            eventAction={eventAction}
            actionData={actionData}
            events={events}
            actions={actions}
            hideModal={hideModal}
            showLoaderForAction={showLoaderForAction}
            version={version}
          />
        );
      case 'updateCellData':
        return (
          <UpdateCollectionCellData
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
          />
        );

      case 'triggerCustomFunction':
        return (
          <FunctionExecution
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
          />
        );
      case 'loginWithOAuth2':
      case 'loginWithFacebook':
      case 'loginWithTwitter':
      case 'verifyEmailOTP':
      case 'verifySmsOTP':
        return (
          <OAuth2LoginForm
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
          />
        );
      case 'amazonTextract':
        return (
          <AmazonTextractForm
            projectId={projectId}
            selectedEvent={selectedEvent}
            eventAction={eventAction}
            actionData={actionData}
            events={events}
            actions={actions}
            hideModal={hideModal}
            showLoaderForAction={showLoaderForAction}
            version={version}
          />
        );
      case 'goToPage':
        return (
          <PageRedirect
            projectId={projectId}
            selectedEvent={selectedEvent}
            eventAction={eventAction}
            actionData={actionData}
            events={events}
            actions={actions}
            hideModal={hideModal}
            showLoaderForAction={showLoaderForAction}
            version={version}
          />
        );
      case 'setBrowserStorageData':
      case 'clearBrowserStorageData':
        return (
          <BrowserStorageActionForm
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
          />
        );
      case 'nlpAnonymization':
        return (
          <NlpAnonymizationForm
            projectId={projectId}
            selectedEvent={selectedEvent}
            eventAction={eventAction}
            actionData={actionData}
            events={events}
            actions={actions}
            hideModal={hideModal}
            showLoaderForAction={showLoaderForAction}
            version={version}
          />
        );
      case 'customTermsAnonymization':
        return (
          <CustomTermsAnonymizationForm
            projectId={projectId}
            selectedEvent={selectedEvent}
            eventAction={eventAction}
            actionData={actionData}
            events={events}
            actions={actions}
            hideModal={hideModal}
            showLoaderForAction={showLoaderForAction}
            version={version}
          />
        );
      case 'runJavaScriptCode':
        return (
          <JavaScriptEditorForm
            projectId={projectId}
            selectedEvent={selectedEvent}
            eventAction={eventAction}
            actionData={actionData}
            events={events}
            actions={actions}
            hideModal={hideModal}
            showLoaderForAction={showLoaderForAction}
            version={version}
          />
        );
      case 'addNewUserToTenant':
        return (
          <AddUserToTenantForm
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            version={version}
            events={events}
          />
        );
      case 'customPageRedirect':
        return (
          <CustomPageRedirect
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            version={version}
          />
        );
      case 'bulkUpdateCollection':
        return (
          <BulkCollectionEdit
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
          />
        );
      case 'sendSocketMessage':
        return (
          <SocketIOActionForm
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
          />
        );
      case 'openFloatingModal':
        return (
          <FloatingModal
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
          />
        );
      case 'saveUserWithTenantsAndUserSetting':
        return (
          <UserWithTenantsAndSettingEventFieldForm
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
          />
        );
      case 'generatePdfFromSnippet':
        return (
          <DownloadPDFTemplate
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
          />
        );
      case 'generateEmailOTP':
      case 'generateSmsOTP':
        return (
          <GenerateOTPForm
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            events={events}
            version={version}
          />
        );
      case 'cloneCollectionItem':
        return (
          <CloneCollectionItemForm
            hideModal={hideModal}
            actions={actions}
            eventAction={eventAction}
            actionData={actionData}
            selectedEvent={selectedEvent}
            showLoaderForAction={showLoaderForAction}
            projectId={projectId}
            version={version}
            events={events}
          />
        );
      default:
        let showArgsModal =
          actionData && actionData.args !== 'undefined' && actionData.args.length > 0;
        if (showArgsModal) {
          return (
            <ActionForm
              hideModal={hideModal}
              actions={actions}
              eventAction={eventAction}
              actionData={actionData}
              selectedEvent={selectedEvent}
              projectId={projectId}
              showLoaderForAction={showLoaderForAction}
              events={events}
              version={version}
              externalApiType={source || ''}
            />
          );
        }
        break;
    }
  };

  displayActionLabel = (label) => {
    return label ? (label === 'Dynamic Page Redirect' ? 'Conditional Redirect' : label) : '';
  };

  getTitleContentLink(actionDescription, eventActions) {
    const actionDescriptionData = actionDescription.find(
      (actionObj) => actionObj.name === eventActions.name,
    );
    const title = actionDescriptionData ? actionDescriptionData.docTitle : '';
    const content = actionDescriptionData ? actionDescriptionData.doc : '';
    const link = actionDescriptionData ? actionDescriptionData.docLink : '';
    const vLink = actionDescriptionData ? actionDescriptionData.videoLink : '';
    return { title, content, link, vLink };
  }

  showIcon = (action) => {
    switch (action.name) {
      case 'triggerZap':
        return (
          <img
            src={require('../../common/dataSource/img/zapier.svg')}
            alt={action.label}
            className="mr-3 svg"
          />
        );
      case 'updateCellData':
        return (
          <img
            src={require('../../common/dataSource/img/Tabulator.png')}
            alt={action.label}
            className="mr-3 svg"
          />
        );
      case 'createConsentRequest':
      case 'fetchFinancialInformation':
      case 'signzyDigitalDocSign':
      case 'fetchContractDetails':
        return (
          <img
            src={require('../../common/dataSource/img/signzy.svg')}
            alt={action.label}
            className="mr-3 svg"
          />
        );
      case 'fetchGoogleCalendarEvents':
      case 'initiateGoogleCalendarAuth':
      case 'syncGoogleCalendarEvents':
      case 'scheduleGoogleCalendarEvent':
      case 'deleteGoogleCalendarEvent':
      case 'updateGoogleCalendarEvent':
        return (
          <img
            src={require('../../common/dataSource/img/google-calendar.svg')}
            alt={action.label}
            className="mr-3 svg"
          />
        );
      case 'initiateGoogleMeetAuth':
      case 'createInstantGoogleMeet':
        return (
          <img
            src={require('../../common/dataSource/img/google-meet.svg')}
            alt={action.label}
            className="mr-3 svg"
          />
        );
      case 'initiateZoomAuth':
      case 'createInstantZoomMeet':
        return (
          <img
            src={require('../../common/dataSource/img/zoom.svg')}
            alt={action.label}
            className="mr-3 svg"
          />
        );
      case 'initiateBoxAuth':
      case 'uploadFileToBox':
        return (
          <img
            src={require('../../common/dataSource/img/box.svg')}
            alt={action.label}
            className="mr-3 svg"
          />
        );
      case 'sendDataToExternalApi':
      case 'sendDataToExternalApiAndAuthorize':
      case 'sendDataToExternalApiAndFileDownload':
      case 'sendDataToExternalSource':
      case 'sendDataToExternalSourceAndFileDownload':
      case 'authorizeWithExternalDataSource':
        if (action.source && action.source === SUPABASE) {
          return (
            <img
              src={require('../../common/dataSource/img/supabase.svg')}
              alt={`${action.label}`}
              className="mr-3 svg"
            />
          );
        } else if (action.source && action.source === DIRECTUS) {
          return (
            <img
              src={require('../../common/dataSource/img/directus.svg')}
              alt={`${action.label}`}
              className="mr-3 svg"
            />
          );
        } else if (action.source && action.source === APP_WRITE) {
          return (
            <img
              src={require('../../common/dataSource/img/appwrite.svg')}
              alt={`${action.label}`}
              className="mr-3 svg"
            />
          );
        } else if (action.source && action.source === XANO) {
          return (
            <img
              src={require('../../common/dataSource/img/xano.svg')}
              alt={`${action.label}`}
              className="mr-3 svg"
            />
          );
        } else if (action.source && action.source === MYSQL) {
          return (
            <img
              src={require('../../common/dataSource/img/mysql.svg')}
              alt={`${action.label}`}
              className="mr-3 svg"
            />
          );
        } else {
          return <i className={`mr-3 wb ${drapcodeIcon(action.name)}`} />;
        }
      case 'addDataKnowledgeBase':
        return <i className={`mr-3 wb ${drapcodeIcon('saveItemInMetaDataTable')}`} />;
      case 'queryFromKnowledgeBase':
      case 'answerFromChatbot':
      case 'continueConversation':
        return <i className={`mr-3 wb ${drapcodeIcon('AI / ChatGPT')}`} />;
      case 'generateQR':
      case 'initiateQRCodeReader':
        return (
          <img
            src={require('../../common/dataSource/img/qr.svg')}
            alt={action.label}
            className="mr-3 svg"
          />
        );
      case 'initiateMPesaC2BPayment':
      case 'initiateMPesaB2CPayout':
      case 'registerMpesaC2BUrls':
        return (
          <img
            src={require('../../common/dataSource/img/m-pesa.svg')}
            alt={action.label}
            className="mr-3 svg"
          />
        );
      case 'metropolCreditReport':
      case 'iprsKenya':
      case 'kraPinChecker':
      case 'eStatementAnalysis':
        return (
          <img
            src={require('../../common/dataSource/img/spin-mobile.svg')}
            alt={action.label}
            className="mr-3 svg"
          />
        );
      case 'boldSignSendDocument':
      case 'boldSignDocumentStatus':
      case 'boldSignEmbeddedRequest':
        return (
          <img
            src={require('../../common/dataSource/img/boldsign.svg')}
            alt={action.label}
            className="mr-3 svg"
          />
        );
      default:
        return <i className={`mr-3 wb ${drapcodeIcon(action.name)}`} />;
    }
  };

  render() {
    const { eventAction, show, hideModal } = this.props;
    const { title, content, link, vLink } = this.getTitleContentLink(
      actionDescription,
      eventAction,
    );

    const largeModalEvents = [
      'dynamicPageRedirect',
      'updateCollectionOnPageLoad',
      'referenceDropDownOnChange',
      'sendDataToExternalApi',
      'saveUserWithCollectionReference',
      'saveCollectionWithReferenceItems',
      'updateCollectionWithReferenceItems',
      'saveCollection',
      'updateCollection',
      'saveCollectionDraft',
      'updateCollectionDraft',
      'runJavaScriptCode',
    ];
    const actionData = this.actionData(eventAction);
    let showArgsModal = actionData && actionData.args !== 'undefined' && actionData.args.length > 0;
    if (actionData && showArgsModal) {
      return (
        <Modal
          isOpen={show && showArgsModal}
          toggle={hideModal}
          backdrop="static"
          style={
            largeModalEvents.includes(eventAction.name)
              ? {
                  maxWidth: ['dynamicPageRedirect'].includes(eventAction.name) ? '800px' : '750px',
                  marginTop: '100px',
                }
              : { marginTop: '100px' }
          }
        >
          <ModalHeader toggle={hideModal} className="border-bottom">
            {this.showIcon(eventAction)}
            <strong>{this.displayActionLabel(eventAction.label)}</strong>
            <span>
              <InfoBox popoverTitle={title} content={content} docLink={link} videoLink={vLink} />
            </span>
          </ModalHeader>
          <ModalBody>{this.actionForm(eventAction, actionData)}</ModalBody>
        </Modal>
      );
    } else {
      return null;
    }
  }
}

export default ActionFormModal;
